import {
  selectExternalFormCompletion,
  selectExternalInfos,
} from '@/domain/external/external.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

export const finishExternalForm = createAppAsyncThunk(
  'external/finishExternalForm',
  async (
    _,
    { extra: { externalGateway, snackbarGateway }, getState },
  ): Promise<void> => {
    const externalInfos = selectExternalInfos(getState());
    const completion = selectExternalFormCompletion(getState());
    const status = 'SUBMITTED';
    try {
      await externalGateway.updateExternalInvitation(
        externalInfos,
        status,
        completion,
      );
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('Error.unknown-error'));
}
